module.exports = __webpack_public_path__ + "static/media/mysql.e7600bc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/mysql.png
// module id = 150
// module chunks = 0